import React from 'react';
import {cn} from '@/utils';
import {useTranslation} from 'react-i18next';

export interface ResultTabProps {
  tabs: {
    key: string;
    label: string;
  }[];
  onSelectKey?: (key: string) => void;
  selectKey?: string;
  activeTabClassName?: string;
  textWrapClassName?: string;
  minuteTextClassName?: string;
}

const ResultTab = ({
  tabs = [],
  onSelectKey,
  selectKey,
  activeTabClassName,
  textWrapClassName,
  minuteTextClassName,
}: ResultTabProps) => {
  const {t} = useTranslation();
  const activeKey = selectKey || tabs[0]?.key;

  return (
    <div className="px-3 flex-none overflow-hidden sticky top-0 z-20 bg-[#F2F2F2]">
      <div className="relative z-20 flex flex-row overflow-auto min-w-full gap-x-2 py-3">
        {tabs.map(item => (
          <button
            type="button"
            key={item.key}
            onClick={() => onSelectKey?.(item.key)}
            className={cn(
              'relative h-12 px-0 bg-white rounded flex flex-row min-w-[5rem] w-[calc(100%-.75rem)] justify-center appearance-none overflow-hidden',
              activeKey === item.key && activeTabClassName,
            )}>
            {activeKey === item.key ? (
              <div className="absolute inset-x-0 top-0 h-[.1875rem] rounded-t bg-c1" />
            ) : null}
            <div
              className={cn(
                'flex flex-row items-center font-bold din text-sm',
                textWrapClassName,
              )}>
              <div className="text-xl">{item.label}</div>
              <div className={cn('text-xs text-acc ml-2', minuteTextClassName)}>
                {t('home.label.minute')}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ResultTab;
